module.exports = {
    NODE_ENV: '"production"',
    hosturl:'http://mp.zizhushizi.com/game-dev/erp'
}